import React from 'react';
import { Overlay, LoadingBalls } from '@moda/om';
import { useSavedItems } from '../../hooks/useSavedItems';
import { ShoppingBagNotification } from './ShoppingBagNotification';
import { pluralize } from './pluralize';
import { useClearMovedAutomaticallyFlags } from './useClearMovedAutomaticallyFlags';

export const MovedToSavedForLaterNotification: React.FC = () => {
  const { savedItems } = useSavedItems();
  const { clearMovedAutomaticallyFlags, loading } = useClearMovedAutomaticallyFlags();

  const movedItems = savedItems.filter(item => item.attributes.movedAutomatically);

  if (movedItems.length === 0) return null;

  return (
    <ShoppingBagNotification
      color="code-red"
      title={
        <>
          {movedItems.length} {pluralize('item', movedItems.length)} in your Shopping Bag{' '}
          {pluralize('is', movedItems.length)} no longer available. We've moved{' '}
          {pluralize('it', movedItems.length)} to your Saved for Later list.
        </>
      }
      onClose={clearMovedAutomaticallyFlags}
    >
      <Overlay show={loading}>
        <LoadingBalls />
      </Overlay>
    </ShoppingBagNotification>
  );
};
